export default "__VITE_ASSET__48fe2b3e__"